<template>
  <div class="top_native">
    <div class="contentText">
      <!-- <img src="@/assets/img/back2.jpg" alt=""> -->
      <img :src="list.length>0?list[0].imgUrl:''" alt="">
    </div>
    <!-- <el-carousel height="100vh" indicator-position="none">
      <el-carousel-item v-for="item in imgs" :key="item">
        <img class="backImg" :src="item.imgUrl" alt="">

      </el-carousel-item>
    </el-carousel> -->
  </div>
</template>


<script>
import back1 from "@/assets/img/back1.jpg"
import back2 from "@/assets/img/back2.jpg"
import { banner } from "@/api/public"
export default {
  data() {
    return {
      bannerList: []
    }
  },
  props:['list'],
  mounted() {
   
  }
}
</script>

<style lang="scss" scoped>
.top_native {
  width: 100%;
  height: 100vh;
  position: relative;

  .backImg {
    width: 100%;

  }

  .contentText {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    img{
      width: 100%;
      height: 100vh;
    }

  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}</style>